/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import type { DateTime, Date } from '@vivaldis/graphql'
export type { DateTime, Date } from '@vivaldis/graphql'
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** Date in ISO 8601 format (yyyy-mm-dd) */
  Date: { input: Date; output: Date }
  /** DateTime in ISO 8601 format (2019-07-15T11:29:45+02:00) */
  DateTime: { input: DateTime; output: DateTime }
}

/** Autogenerated input type of AcceptTermsAndConditions */
export type AcceptTermsAndConditionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
}

/** Autogenerated input type of AddUserToCompany */
export type AddUserToCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId: string
  user: UserInput
}

export type ApprovePositionInput = {
  committeeId: string
  isConstruct: boolean
  isFlexi: boolean
  minimumWage: number
  safetyQuestion?: string | null
  vivaldisOfficeCode: string
}

export type AttachmentInput = {
  base64: string
  fileName: string
}

export enum BrandsEnum {
  BRICKJOBS = 'BRICKJOBS',
  VIVACONNECT = 'VIVACONNECT'
}

/** Company onboarding commercial data properties */
export type CommercialDataInput = {
  buildingNumber?: string | null
  city: string
  committees?: CommitteeInput[] | null
  dayContractsAllowed: boolean
  name: string
  officialName?: string | null
  preventionContractNumber?: string | null
  preventionServices?: PreventionServicesEnum[] | null
  street: string
  streetNumber: string
  vat: string
  zip: string
}

/** Company onboarding joint committee properties */
export type CommitteeInput = {
  averageWeeklyHours: number
  averageWeeklyHoursByYear: number
  code: string
  isWorker: boolean
  name: string
  overtimePayingStatus: OvertimePayingStatusesEnum
}

export enum CompanyFeaturesEnum {
  DIMONA_ATTESTATION = 'DIMONA_ATTESTATION',
  WEATHER_OBSTRUCTIONS = 'WEATHER_OBSTRUCTIONS'
}

export type CompanyInput = {
  buildingNumber?: string | null
  city?: string | null
  logoAttachment?: AttachmentInput | null
  name?: string | null
  street?: string | null
  streetNumber?: string | null
  zip?: string | null
}

export enum CompanyTypesEnum {
  CONSTRUCT = 'CONSTRUCT',
  INTERIM = 'INTERIM'
}

/** Autogenerated input type of ConfirmAgreements */
export type ConfirmAgreementsInput = {
  agreements: string[]
  brand?: BrandsEnum | null
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
}

export type ContractCancellationRequestDecisionInput = {
  approved: boolean
  contractId: string
}

export type ContractCancellationRequestInput = {
  contractId: string
  reason: string
}

export type ContractInput = {
  attemptsCount?: number | null
  buildingNumber?: string | null
  city?: string | null
  confirmedFullTime: boolean
  contractPremiums: PremiumValuesInput[]
  contractReason: ContractReasonsEnum
  costPlace?: string | null
  countryId?: string | null
  latitude?: number | null
  longitude?: number | null
  remark?: string | null
  street: string
  streetNumber?: string | null
  vcaExamDate?: Date | null
  wage: number
  wageUpdateComment?: string | null
  workdays: WorkdayInput[]
  zip?: string | null
}

export enum ContractReasonsEnum {
  INSTROOM = 'INSTROOM',
  TIJDELIJKE_VERMEERDERING_VAN_WERK = 'TIJDELIJKE_VERMEERDERING_VAN_WERK',
  UITZONDERLIJK_WERK = 'UITZONDERLIJK_WERK',
  VERVANGING_VOOR_EINDE_VAN_OVEREENKOMST = 'VERVANGING_VOOR_EINDE_VAN_OVEREENKOMST',
  VERVANGING_VOOR_SCHORSING_VAN_OVEREENKOMST = 'VERVANGING_VOOR_SCHORSING_VAN_OVEREENKOMST'
}

export enum ContractStatesEnum {
  CLOSED = 'CLOSED',
  IN_QUEUE = 'IN_QUEUE',
  PENDING = 'PENDING'
}

/** Autogenerated input type of CreateContractCancellationRequest */
export type CreateContractCancellationRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  request: ContractCancellationRequestInput
}

/** Autogenerated input type of CreateContracts */
export type CreateContractsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  contract: ContractInput
  employeeId: string
  positionId: string
}

/** Autogenerated input type of CreateCostPlace */
export type CreateCostPlaceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId?: string | null
  name: string
}

/** Autogenerated input type of CreateEmployeeCertificate */
export type CreateEmployeeCertificateInput = {
  certificate: EmployeeCertificateInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId?: string | null
}

/** Autogenerated input type of CreateEmployeeEducation */
export type CreateEmployeeEducationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeEducation: EmployeeEducationInput
}

/** Autogenerated input type of CreateMedicalFile */
export type CreateMedicalFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  medicalFile: MedicalFileInput
}

/** Autogenerated input type of CreatePosition */
export type CreatePositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  /** Obligatory only if current user is super user. In case of ordinary user this value is ignored. */
  companyId?: string | null
  position: PositionInput
}

/** Autogenerated input type of CreateWeatherObstructions */
export type CreateWeatherObstructionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  weatherObstructions: WeatherObstructionInput[]
}

/** Autogenerated input type of CreateWorkPostSheet */
export type CreateWorkPostSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  positionId: string
  workPostSheet: WorkPostSheetInput
}

/** Autogenerated input type of CreateWorkdaysCancellationRequest */
export type CreateWorkdaysCancellationRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  request: WorkdaysCancellationRequestInput
}

/** Autogenerated input type of DeleteContract */
export type DeleteContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
}

/** Autogenerated input type of DeleteCostPlace */
export type DeleteCostPlaceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
}

/** Autogenerated input type of DeleteEmployeeCertificate */
export type DeleteEmployeeCertificateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
}

/** Autogenerated input type of DeleteEmployeeEducation */
export type DeleteEmployeeEducationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
}

export type DimonaContactInput = {
  email: string
  firstName: string
  language: string
  lastName: string
}

export enum DocumentSubtypesEnum {
  ALIEN_PASSPORT = 'ALIEN_PASSPORT',
  DIPLOMATIC_PASSPORT = 'DIPLOMATIC_PASSPORT',
  EMERGENCY_PASSPORT = 'EMERGENCY_PASSPORT',
  LAISSEZ_PASSER_PASSPORT = 'LAISSEZ_PASSER_PASSPORT',
  MILITARY_PASSPORT = 'MILITARY_PASSPORT',
  OFFICIAL_PASSPORT = 'OFFICIAL_PASSPORT',
  ORDINARY_PASSPORT = 'ORDINARY_PASSPORT',
  REFUGEE_PASSPORT = 'REFUGEE_PASSPORT',
  STATELESS_PASSPORT = 'STATELESS_PASSPORT',
  UNDEFINED_PASSPORT_SUBTYPE = 'UNDEFINED_PASSPORT_SUBTYPE'
}

export enum DocumentTypesEnum {
  ID_CARD = 'ID_CARD',
  PASSPORT = 'PASSPORT'
}

export type EmployeeCertificateInput = {
  certificateType: string
  expiresOn?: Date | null
  scannedDocumentBackUrlAttachment?: AttachmentInput | null
  scannedDocumentUrlAttachment?: AttachmentInput | null
}

export type EmployeeEducationInput = {
  educationSubjectId: string
  graduationYear: number
  institute: string
}

export type EmployeeInput = {
  email?: string | null
  firstName?: string | null
  isStudent?: boolean | null
  lastName?: string | null
  mobile?: string | null
  preferredLanguage?: string | null
  profile?: EmployeeProfileInput | null
  ssn?: string | null
  workProfile?: EmployeeWorkProfileInput | null
}

export type EmployeeProfileInput = {
  buildingNumber?: string | null
  city?: string | null
  countryId?: string | null
  countryOfBirthId?: string | null
  idCardExpiresOn?: Date | null
  idCardNumber?: string | null
  nationalityCountryId?: string | null
  pictureAttachment?: AttachmentInput | null
  placeOfBirth?: string | null
  street?: string | null
  streetNumber?: string | null
  zip?: string | null
}

export enum EmployeeStatesEnum {
  AWAITING_REGISTRATION = 'AWAITING_REGISTRATION',
  CONTRACT_READY = 'CONTRACT_READY',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED'
}

export enum EmployeeTypesEnum {
  CLERK = 'CLERK',
  WORKER = 'WORKER'
}

export type EmployeeWorkProfileInput = {
  bankAccount?: string | null
  bic?: string | null
  childrenNumber?: number | null
  childrenWithDisabilitiesNumber?: number | null
  dependentPersonsNumber?: number | null
  dependentPersonsWithDisabilitiesNumber?: number | null
  involuntaryPartTime?: boolean | null
  isRetired?: boolean | null
  maritalDate?: Date | null
  maritalState?: MaritalStatesEnum | null
  residencePermitBackPictureAttachment?: AttachmentInput | null
  residencePermitCode?: string | null
  residencePermitExpiresOn?: Date | null
  residencePermitFrontPictureAttachment?: AttachmentInput | null
  retiredOn?: Date | null
  taxCode?: string | null
  workPermitBackPictureAttachment?: AttachmentInput | null
  workPermitExpiresOn?: Date | null
  workPermitFrontPictureAttachment?: AttachmentInput | null
}

/** Autogenerated input type of ExtendContract */
export type ExtendContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  confirmFullTime: boolean
  contractId: string
  costPlace?: string | null
  vcaExamDate?: Date | null
  workdays: WorkdayInput[]
}

export enum FeatureTypesEnum {
  PAYROLL = 'PAYROLL',
  SELECTION = 'SELECTION'
}

/** Autogenerated input type of FillCompanySurvey */
export type FillCompanySurveyInput = {
  answers: SurveyAnswerInput[]
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  surveyId: string
}

/** Autogenerated input type of FillEmployeeSurvey */
export type FillEmployeeSurveyInput = {
  answers: SurveyAnswerInput[]
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  surveyId: string
}

export enum GendersEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export enum InsuranceProvidersEnum {
  BOND_MOYSON = 'BOND_MOYSON',
  CHRISTELIJKE_MUTUALITEIT = 'CHRISTELIJKE_MUTUALITEIT',
  DE_VOORZORG = 'DE_VOORZORG',
  FREIE_KRANKENKASSE = 'FREIE_KRANKENKASSE',
  GEWESTELIJKE_DIENST = 'GEWESTELIJKE_DIENST',
  HULPKAS_VOOR_ZIEKTE = 'HULPKAS_VOOR_ZIEKTE',
  LANDSBOND_VAN_LIBERALE_MUTUALITEITEN = 'LANDSBOND_VAN_LIBERALE_MUTUALITEITEN',
  NATIONAAL_VERBOND_VAN_SOCIALISTISCHE_MUTUALITEITEN = 'NATIONAAL_VERBOND_VAN_SOCIALISTISCHE_MUTUALITEITEN',
  NEUTRAAL_ZIEKENFONDS_ALGEMEEN = 'NEUTRAAL_ZIEKENFONDS_ALGEMEEN',
  NEUTRAAL_ZIEKENFONDS_VLAANDEREN = 'NEUTRAAL_ZIEKENFONDS_VLAANDEREN',
  OMNIMUT = 'OMNIMUT',
  ONAFHANKELIJK_ZIEKENFONDS = 'ONAFHANKELIJK_ZIEKENFONDS',
  PARTENA = 'PARTENA',
  SOLIDARIS = 'SOLIDARIS',
  SYMBIO = 'SYMBIO',
  VLAAMS_NEUTRAAL_ZIEKENFONDS = 'VLAAMS_NEUTRAAL_ZIEKENFONDS'
}

/** Autogenerated input type of InviteToTeam */
export type InviteToTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  /** Used only if super user is inviting employee to the company team. */
  companyId?: string | null
  email: string
  firstName: string
  lastName: string
  locale: string
}

export enum MaritalStatesEnum {
  DIVORCED = 'DIVORCED',
  LEGALLY_DIVORCED = 'LEGALLY_DIVORCED',
  LIVING_TOGETHER = 'LIVING_TOGETHER',
  MARRIED = 'MARRIED',
  NOT_MARRIED = 'NOT_MARRIED',
  WIDOW = 'WIDOW'
}

/** Properties for creating/updating employee's medical file */
export type MedicalFileInput = {
  accidents?: string | null
  hadAccidents?: boolean | null
  hadFainting?: boolean | null
  hasAllVaccinations?: boolean | null
  hasAsthmaOrAllergy?: boolean | null
  hasDiabetes?: boolean | null
  hasIllnessHistory?: boolean | null
  hasPhysicalComplaints?: boolean | null
  hasPsychologicalComplaints?: boolean | null
  illnessDetails?: string | null
  insuranceProvider: InsuranceProvidersEnum
  medications?: string | null
  missingVaccinations?: string | null
  physicalComplaints?: string | null
  physicianAddress?: string | null
  physicianName?: string | null
  physicianPhone?: string | null
  psychologicalComplaints?: string | null
  usesMedications?: boolean | null
}

export enum OcrStatesEnum {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
  UNDEFINED = 'UNDEFINED'
}

export enum OvertimePayingStatusesEnum {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NOT_PAID = 'NOT_PAID',
  PAID = 'PAID'
}

export enum PositionApprovalStatesEnum {
  APPROVED = 'APPROVED',
  WAITING_APPROVAL = 'WAITING_APPROVAL'
}

/** Properties for creating/updating position */
export type PositionInput = {
  certificateTypes: string[]
  city?: string | null
  countryId?: string | null
  /** Description of position */
  description?: string | null
  ecoChequeComment?: string | null
  functionCodeId: string
  latitude?: number | null
  longitude?: number | null
  /** Name of position */
  name: string
  nettoPremiumComment?: string | null
  noVatApplicable: boolean
  street: string
  streetNumber?: string | null
  studentsAllowed?: boolean | null
  workEquipmentRequired?: boolean | null
  wpsRequired?: boolean | null
  zip?: string | null
}

export enum PremiumUnitsEnum {
  PERCENT = 'PERCENT',
  PER_DAY = 'PER_DAY',
  PER_HOUR = 'PER_HOUR',
  PER_KILOMETER = 'PER_KILOMETER',
  PER_WEEK = 'PER_WEEK'
}

export type PremiumValuesInput = {
  contributionValue?: number | null
  premiumId: string
  unit: PremiumUnitsEnum
  value?: number | null
}

export enum PreventionServicesEnum {
  ATTENTIA = 'ATTENTIA',
  CESI = 'CESI',
  CLB_EDPB = 'CLB_EDPB',
  COHEZIO = 'COHEZIO',
  IDEWE = 'IDEWE',
  INTERNAL_ADVISOR = 'INTERNAL_ADVISOR',
  LIANTIS = 'LIANTIS',
  MEDIWET = 'MEDIWET',
  MENSURA = 'MENSURA',
  PREMED = 'PREMED',
  REQUESTED = 'REQUESTED',
  SECUREX = 'SECUREX'
}

/** Autogenerated input type of ProcessEmployeeDocument */
export type ProcessEmployeeDocumentInput = {
  backPicture: AttachmentInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId?: string | null
  frontPicture: AttachmentInput
}

export type PushNotificationDeviceInput = {
  /** Device/phone manufacturer */
  brand?: string | null
  /** Language for push notification messages. */
  locale?: string | null
  /** Device/phone model */
  model?: string | null
  /** Device/phone name */
  name?: string | null
  /** Operating system name */
  systemName?: string | null
  /** Operating system version */
  systemVersion?: string | null
  /** Token that is used to uniquely identify device/phone. */
  token: string
}

/** Autogenerated input type of RegisterAdditionalCompany */
export type RegisterAdditionalCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  company: CommercialDataInput
}

/** Autogenerated input type of RegisterPushNotificationDevice */
export type RegisterPushNotificationDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  device: PushNotificationDeviceInput
}

/** Autogenerated input type of RemoveFromTeam */
export type RemoveFromTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  /** Used only if super user is inviting employee to the company team. */
  companyId?: string | null
  employeeId: string
}

/** Autogenerated input type of RequestFeature */
export type RequestFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  featureType: FeatureTypesEnum
}

/** Autogenerated input type of RevokeAccessToCompany */
export type RevokeAccessToCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId: string
  userId: string
}

export type SafetyAnswerInput = {
  answer: string
  employeeId?: string | null
  positionId: string
}

/** Autogenerated input type of SelectCompany */
export type SelectCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId: string
}

/** Autogenerated input type of SendDimonaContactsTo4d */
export type SendDimonaContactsTo4dInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId?: string | null
  dimonaContacts: DimonaContactInput[]
}

/** Autogenerated input type of SendInvitationReminder */
export type SendInvitationReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId: string
  employeeId: string
}

/** Autogenerated input type of SendMissingContractInformationPushNotification */
export type SendMissingContractInformationPushNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId: string
}

/** Autogenerated input type of SetCommercialData */
export type SetCommercialDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  company: CommercialDataInput
}

/** Autogenerated input type of SetPassword */
export type SetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  password: string
  passwordConfirmation: string
}

/** Autogenerated input type of SetPositionPremiums */
export type SetPositionPremiumsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
  positionPremiums: PremiumValuesInput[]
}

/** Autogenerated input type of SetSafetyAnswer */
export type SetSafetyAnswerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  safetyAnswer: SafetyAnswerInput
}

/** Autogenerated input type of SuApprovePosition */
export type SuApprovePositionInput = {
  approvalData: ApprovePositionInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  positionId: string
}

/** Autogenerated input type of SuContractCancellationRequestDecision */
export type SuContractCancellationRequestDecisionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  decision: ContractCancellationRequestDecisionInput
}

/** Autogenerated input type of SuConvertExtensionToContract */
export type SuConvertExtensionToContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  extensionId: string
}

/** Autogenerated input type of SuCreateContractInBackOffice */
export type SuCreateContractInBackOfficeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  comment?: string | null
  contractId: string
  taxDeductible?: boolean | null
}

/** Autogenerated input type of SuCreateNote */
export type SuCreateNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId: string
  note: string
}

/** Autogenerated input type of SuDeletePosition */
export type SuDeletePositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  positionId: string
}

/** Autogenerated input type of SuEnableCostPlaces */
export type SuEnableCostPlacesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId: string
  enabled: boolean
}

/** Autogenerated input type of SuForceCreateExtensionInBackOffice */
export type SuForceCreateExtensionInBackOfficeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  extensionId: string
}

/** Autogenerated input type of SuMissingCertificateReminder */
export type SuMissingCertificateReminderInput = {
  certificateType: string
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId: string
}

/** Autogenerated input type of SuMissingSafetyAnswerReminder */
export type SuMissingSafetyAnswerReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId: string
  safetyQuestion: string
}

/** Autogenerated input type of SuPushWeatherObstruction */
export type SuPushWeatherObstructionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
}

/** Autogenerated input type of SuRejectPosition */
export type SuRejectPositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  positionId: string
}

/** Autogenerated input type of SuScrapeStudentHours */
export type SuScrapeStudentHoursInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId: string
}

/** Autogenerated input type of SuSnoozeMissingCertificate */
export type SuSnoozeMissingCertificateInput = {
  certificateType: string
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId: string
  reason: string
  snoozeUntil: Date
}

/** Autogenerated input type of SuUpdateCompanyFromConnexys */
export type SuUpdateCompanyFromConnexysInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId: string
}

export type SuUpdatePosInput = {
  minimumWage?: number | null
  vivaldisOfficeCode?: string | null
}

/** Autogenerated input type of SuUpdatePosition */
export type SuUpdatePositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
  position: SuUpdatePosInput
}

/** Autogenerated input type of SuUpdateUser */
export type SuUpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
  user: UserInput
}

/** Autogenerated input type of SuVerifyEmployee */
export type SuVerifyEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeId: string
}

/** Autogenerated input type of SuWorkdaysCancellationRequestDecision */
export type SuWorkdaysCancellationRequestDecisionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  decisions: WorkdayCancellationRequestDecisionInput[]
}

export type SurveyAnswerInput = {
  boolValue?: boolean | null
  questionId: string
  textValue?: string | null
}

export enum SurveyStatesEnum {
  ANY = 'ANY',
  CLOSED = 'CLOSED',
  OPENED = 'OPENED'
}

export type TeamMemberInput = {
  disabled: boolean
}

export enum TemporaryUnemploymentDataSetsEnum {
  BAD_WEATHER = 'BAD_WEATHER',
  RISK = 'RISK',
  WORK_AND_REASON = 'WORK_AND_REASON'
}

/** Autogenerated input type of UnregisterPushNotificationDevice */
export type UnregisterPushNotificationDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  token: string
}

/** Autogenerated input type of UpdateCompany */
export type UpdateCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  company: CompanyInput
  id?: string | null
}

/** Autogenerated input type of UpdateCompanySettings */
export type UpdateCompanySettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId?: string | null
  features: CompanyFeaturesEnum[]
}

/** Autogenerated input type of UpdateContracts */
export type UpdateContractsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  data: ContractInput
  ids: string[]
}

/** Autogenerated input type of UpdateEmployeeCertificate */
export type UpdateEmployeeCertificateInput = {
  certificate: EmployeeCertificateInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
}

/** Autogenerated input type of UpdateEmployeeEducation */
export type UpdateEmployeeEducationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employeeEducation: EmployeeEducationInput
  id: string
}

/** Autogenerated input type of UpdateEmployee */
export type UpdateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  employee: EmployeeInput
  id?: string | null
}

/** Autogenerated input type of UpdateMedicalFile */
export type UpdateMedicalFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
  medicalFile: MedicalFileInput
}

/** Autogenerated input type of UpdatePosition */
export type UpdatePositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  id: string
  position: PositionInput
}

/** Autogenerated input type of UpdateTeamMember */
export type UpdateTeamMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  companyId: string
  employeeId: string
  teamMember: TeamMemberInput
}

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  user: UserInput
}

/** Autogenerated input type of UpdateUserMailSettings */
export type UpdateUserMailSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null
  mailSettings: UserMailSettingInput[]
  userId?: string | null
}

export type UserInput = {
  email: string
  firstName: string
  lastName: string
  mobile?: string | null
  preferredLanguage?: string | null
  telephone?: string | null
}

export type UserMailSettingInput = {
  isEnabled: boolean
  mail: UserMailsEnum
}

export enum UserMailsEnum {
  EMPLOYEE_IS_CONTRACT_READY = 'EMPLOYEE_IS_CONTRACT_READY',
  EXTENSION_REMINDER = 'EXTENSION_REMINDER',
  POSITION_APPROVED = 'POSITION_APPROVED',
  POSITION_REJECTED = 'POSITION_REJECTED',
  SURVEY = 'SURVEY'
}

export type WeatherObstructionInput = {
  city: string
  comment?: string | null
  countryId: string
  risk: string
  street: string
  streetNumber?: string | null
  weather: string
  workAndReason: string
  workdayId: string
  zip: string
}

/** Properties for creating/updating work post sheet */
export type WorkPostSheetInput = {
  foreseeableTraining?: string | null
  items?: WorkPostSheetItemInput[] | null
  priorInstructions?: string | null
  requiredQualifications?: string | null
  tasksToPerform?: string | null
  welcomeOfficer?: string | null
  welcomeOfficerPosition?: string | null
  workEquipment?: string | null
  workstationLocation?: string | null
}

/** Properties for creating/updating work post sheet item */
export type WorkPostSheetItemInput = {
  comment?: string | null
  commentAttachment?: AttachmentInput | null
  name: WorkPostSheetItemTypesEnum
}

export enum WorkPostSheetItemTypesEnum {
  ADVICE_BY_COMITE_PWB = 'ADVICE_BY_COMITE_PWB',
  ADVICE_BY_DIRECT_EMPLOYEE_PARTICIPATION = 'ADVICE_BY_DIRECT_EMPLOYEE_PARTICIPATION',
  ADVICE_BY_SYNDICATE_REP = 'ADVICE_BY_SYNDICATE_REP',
  ADVICE_DATE = 'ADVICE_DATE',
  ADVICE_DATE_INTERNAL_SERVICE = 'ADVICE_DATE_INTERNAL_SERVICE',
  ADVICE_DATE_LABOR_DOCTOR = 'ADVICE_DATE_LABOR_DOCTOR',
  BIOLOGICAL_AGENTS = 'BIOLOGICAL_AGENTS',
  BREASTFEEDING_ADJUSTEMENTS_DATE = 'BREASTFEEDING_ADJUSTEMENTS_DATE',
  BREASTFEEDING_ADJUSTMENTS = 'BREASTFEEDING_ADJUSTMENTS',
  CHEMICAL_AGENTS = 'CHEMICAL_AGENTS',
  COAT = 'COAT',
  DUST_JACKET = 'DUST_JACKET',
  ERGONOMIC_LOAD = 'ERGONOMIC_LOAD',
  FUNCTION_WITH_INCREASED_VIGILANCE = 'FUNCTION_WITH_INCREASED_VIGILANCE',
  GLASSES_SAFETY_SCREEN = 'GLASSES_SAFETY_SCREEN',
  GLOVES_MITTENS = 'GLOVES_MITTENS',
  HANDLING_LOADS = 'HANDLING_LOADS',
  HEARING_PROTECTION = 'HEARING_PROTECTION',
  HELMET = 'HELMET',
  HEPATITIS_B = 'HEPATITIS_B',
  MASK = 'MASK',
  NIGHT_WORK = 'NIGHT_WORK',
  NOISE = 'NOISE',
  OINTMENTS = 'OINTMENTS',
  OTHER_EQUIPMENT = 'OTHER_EQUIPMENT',
  OTHER_VACCINATIONS_TESTS = 'OTHER_VACCINATIONS_TESTS',
  PANTS_OVERALL = 'PANTS_OVERALL',
  PDF_URL = 'PDF_URL',
  PREGNANCY_ADJUSTMENTS = 'PREGNANCY_ADJUSTMENTS',
  PREGNANCY_ADJUSTMENTS_DATE = 'PREGNANCY_ADJUSTMENTS_DATE',
  SAFETY_BELT_HARNESS = 'SAFETY_BELT_HARNESS',
  SAFETY_FUNCTION = 'SAFETY_FUNCTION',
  SAFETY_SHOES = 'SAFETY_SHOES',
  SHIFT_WORK = 'SHIFT_WORK',
  TETANUS = 'TETANUS',
  TUBERCULOSE = 'TUBERCULOSE',
  YOUNGER = 'YOUNGER'
}

export type WorkdayCancellationRequestDecisionInput = {
  approved: boolean
  workdayId: string
}

export type WorkdayInput = {
  breakInMinutes: number
  endsAt: DateTime
  startsAt: DateTime
}

export type WorkdaysCancellationRequestInput = {
  reason: string
  workdayIds: string[]
}
